module.exports = __webpack_public_path__ + "img/solution-securityTest-function-icon-2.813ff25d.svg";